var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChartBar = function SvgChartBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.25 13a.25.25 0 0 0-.25-.25H4a.25.25 0 0 0-.25.25v6a.25.25 0 0 0 .25.25h4a.25.25 0 0 0 .25-.25zm1.5 6A1.75 1.75 0 0 1 8 20.75H4A1.75 1.75 0 0 1 2.25 19v-6A1.75 1.75 0 0 1 4 11.25h4A1.75 1.75 0 0 1 9.75 13zM20.25 9a.25.25 0 0 0-.25-.25h-4a.25.25 0 0 0-.25.25v10a.25.25 0 0 0 .25.25h4a.25.25 0 0 0 .25-.25zm1.5 10A1.75 1.75 0 0 1 20 20.75h-4A1.75 1.75 0 0 1 14.25 19V9A1.75 1.75 0 0 1 16 7.25h4A1.75 1.75 0 0 1 21.75 9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.25 5a.25.25 0 0 0-.25-.25h-4a.25.25 0 0 0-.25.25v14a.25.25 0 0 0 .25.25h4a.25.25 0 0 0 .25-.25zm1.5 14A1.75 1.75 0 0 1 14 20.75h-4A1.75 1.75 0 0 1 8.25 19V5A1.75 1.75 0 0 1 10 3.25h4A1.75 1.75 0 0 1 15.75 5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 19.25a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5z"
  })));
};
export default SvgChartBar;